module.exports = __webpack_public_path__ + "img/img15.32963e37.svg";